export default {"src":"/_next/static/media/questionMark.f50e0620.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};